class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

(() => {
  const sidebar = document.getElementById('halo-cart-sidebar');
  const header = sidebar?.querySelector('.halo-sidebar-header');

  if (!sidebar || !header || sidebar.dataset.headerShadowBound === 'true') return;

  sidebar.dataset.headerShadowBound = 'true';

  const updateHeaderShadow = (scroller) => {
    const shouldShow = Boolean(
      scroller &&
      scroller.scrollTop > 0 &&
      !document.body.classList.contains('thehood-added-cart-drawer')
    );

    header.classList.toggle('is-stuck', shouldShow);
  };

  sidebar.addEventListener('scroll', (event) => {
    if (event.target.matches?.('.previewCart')) {
      updateHeaderShadow(event.target);
    }
  }, true);

  document.addEventListener('cart-update', () => {
    requestAnimationFrame(() => {
      updateHeaderShadow(sidebar.querySelector('.previewCart'));
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-sidebar], [data-close-cart-sidebar]')) {
      header.classList.remove('is-stuck');
    }
  });
})();
